/**
 * @generated SignedSource<<767478a56a3b2169f552ada3abf3f8b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreatePayrateInput = {
  clientMutationId?: string | null | undefined;
  startDate: string;
};
export type CreatePayrateMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreatePayrateInput;
};
export type CreatePayrateMutation$data = {
  readonly createPayrate: {
    readonly errors: any | null | undefined;
    readonly payrate: {
      readonly hourlyRate: number | null | undefined;
      readonly id: string;
      readonly startDate: string | null | undefined;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type CreatePayrateMutation = {
  response: CreatePayrateMutation$data;
  variables: CreatePayrateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "PayrateNode",
  "kind": "LinkedField",
  "name": "payrate",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hourlyRate",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreatePayrateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreatePayratePayload",
        "kind": "LinkedField",
        "name": "createPayrate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreatePayrateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreatePayratePayload",
        "kind": "LinkedField",
        "name": "createPayrate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "payrate",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "PayrateNodeEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "961318b7844a4b02d6f8ba39462d47ea",
    "id": null,
    "metadata": {},
    "name": "CreatePayrateMutation",
    "operationKind": "mutation",
    "text": "mutation CreatePayrateMutation(\n  $input: CreatePayrateInput!\n) {\n  createPayrate(input: $input) {\n    success\n    errors\n    payrate {\n      id\n      startDate\n      hourlyRate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7ee5c68ebfac85dba11ccb1cb4d3e438";

export default node;
